import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import CircularProgress from '@material-ui/core/CircularProgress';
import '../../assets/css/main.css';
// import PrivacyNoticeData from './privacyNo‎tice.json';
import theme from '../../styles/theme.js';

const PrivacyNotice = (props) => {
  const classes = useStyles();
  const date = new Date(1749237389000);

  return (
    <div>
      <div className='privacy-container'>
        <div className='NavBar-area' />
        <div className='container'>
          {/* {isLoading ? (
            <div className='styleCircularProgress'>
              <CircularProgress color='secondary' />
            </div>
          ) : ( */}
            <>
              <div className={classes.container}>
                {/* {PrivacyNoticeData.content.map((element) => {
                  switch (element.type) {
                    case 'title':
                      return (
                        <>
                          <text
                            className={`${classes.title} ${classes.defaultText}`}
                          >
                            {element.value}
                          </text>
                          {element.space ? <br /> : null}
                        </>
                      );
                    case 'date':
                      return (
                        <>
                          <text
                            className={`${classes.subTitle} ${classes.defaultText}`}
                          >
                            {element.value}
                          </text>
                          {element.space ? <br /> : null}
                        </>
                      );
                    case 'subTitle':
                      return (
                        <>
                          <br />
                          <text
                            className={`${classes.subTitle} ${classes.defaultText}`}
                          >
                            {element.value}
                          </text>
                          {element.space ? <br /> : null}
                          <br />
                        </>
                      );
                    case 'paragraph':
                      return (
                        <>
                          <text className={`${classes.defaultText}`}>
                            {element.value}
                          </text>
                          {element.space ? <br /> : null}
                        </>
                      );
                    case 'list':
                      return (
                        <>
                          <span className={`${classes.defaultText}`}>
                            {'• '}
                            {element.value}
                          </span>
                          {element.space ? <br /> : null}
                        </>
                      );
                    case 'link':
                      return (
                        <>
                          <a
                            href={element.value}
                            target='_blank'
                            className={`${classes.link} ${classes.defaultText}`}
                            rel='noopener noreferrer'
                            // onMouseEnter={()=> { setHover(true)}}
                            // onMouseLeave={()=> { setHover(false)}}
                          >
                            {element.value}
                          </a>
                          {element.space ? <br /> : null}
                        </>
                      );
                    case 'link-email':
                      return (
                        <>
                          <a
                            href={`mailto:${element.value}`}
                            target='_blank'
                            className={`${classes.link} ${classes.defaultText}`}
                            rel='noopener noreferrer'
                            // onMouseEnter={()=> { setHover(true)}}
                            // onMouseLeave={()=> { setHover(false)}}
                          >
                            {element.value}
                          </a>
                          {element.space ? <br /> : null}
                        </>
                      );
                    default:
                      return (
                        <text
                          className={`${classes.subTitle} ${classes.defaultText}`}
                        >
                          {element.value}
                        </text>
                      );
                  }
                })} */}
                <text className={classes.title}> Aviso de privacidad </text>
                <p className={classes.subTitle}>
                  Fecha de actualización: {date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  })}
                </p>
                <iframe src='/documents/privacyPolicy.pdf#toolbar=0' width="100%" height="100vh" style={{height: '100vh'}}/>
              </div>
            </>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;

const rem = 16;

const useStyles = makeStyles({
  defaultText: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: 500,
  },
  container: {
    backgroundColor: theme.palette.white.main,
    width: 'calc(80%)',
    padding: '5%',
    borderRadius: 20,
    marginBottom: '5%',
    marginTop: '2%',
  },
  title: {
    // width: '60%',
      fontSize: 2.25 * rem,
    textAlign: 'center',
    fontWeight: 900,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      textAlign: 'center'
    },
  },
  subTitle: {
    fontSize: 1.25 * rem,
    fontWeight: 700,
    textAlign: 'right',
    marginBottom: '2%',
  },
  link: {
    color: theme.palette.primary.main,
    ':visited': {
      color: 'pink',
    },
  },
});